module.exports = __webpack_public_path__ + "img/dial3.fe3226b1.png";